import(/* webpackMode: "eager" */ "/vercel/path0/components/BookingButton.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/CloudImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/CtaSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/FAQ.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/HeroSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/ParallaxSection.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/MediaContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
